import { getFeatureLayerID } from './map.utils';
import store from '../store/store';

/**
 * Get Indicator key
 * @returns {string} - Indicator key
 */
export function getIndicatorKey(adminPreferred?: string): string {
  const { value: indicatorSelectedID } = store.getState().admin2EstimatesSlice.indicatorSelected;
  const admin1ClientSideFeaturesLayerID = getFeatureLayerID(adminPreferred);

  return `${admin1ClientSideFeaturesLayerID}_${indicatorSelectedID}`;
}
